module.exports = __webpack_public_path__ + "img/yishi17.2b4a6d0b.jpg";